import { generateId, TIPTAP_GIF_TYPE } from "./../../ricos-content";
import { TIPTAP_FIGURE_TYPE } from "./../../ricos-content/consts";
import { GIFData_GIFType, Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const gifConverter = {
  toPm: {
    types: [Node_Type.GIF],
    // @ts-ignore $TSFixMe
    convert: (node, visit) => {
      const fallbackCaption = {
        id: generateId(),
        type: Node_Type.CAPTION,
        nodes: []
      };
      return {
        type: TIPTAP_FIGURE_TYPE,
        attrs: {
          id: generateId()
        },
        content: [
          {
            type: TIPTAP_GIF_TYPE,
            attrs: {
              ...node.gifData,
              id: node.id
            }
          },
          ...visit(node.nodes?.length > 0 ? node : { ...node, nodes: [fallbackCaption] })
        ]
      };
    }
  },
  fromPm: {
    types: [TIPTAP_FIGURE_TYPE, TIPTAP_GIF_TYPE],
    convert: (node, visit) => {
      if (node.type === TIPTAP_GIF_TYPE) {
        return void 0;
      }
      const gifNode = node.content?.find(({ type }) => type === TIPTAP_GIF_TYPE);
      if (!gifNode) {
        return void 0;
      }
      const { id, ...data } = gifNode?.attrs || {};
      const gifType = data.gifType === GIFData_GIFType.STICKER ? data.gifType : void 0;
      const [captionNode] = visit?.(node) ?? [];
      return {
        type: Node_Type.GIF,
        id: id ?? generateId(),
        nodes: captionNode?.nodes[0]?.textData?.text ? [captionNode] : [],
        gifData: {
          ...data,
          gifType
        }
      };
    }
  }
};
export {
  gifConverter
};
//# sourceMappingURL=gif-converter.js.map
